<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/system'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
  />
</template>
<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import { FeatureStorage } from "@/_services/storage";

export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        Code: "",
        Description: "",
        FactorInt: 0,
        Factorc: "",
        IsTextSetting: false,
      },
      data: {
        title: "System Parameters",
        pageRoute: "/system-parameters",
        recordEndPoint: "Factor",
        updateEndPoint: "Factor",
        updateKeyField: "Code",
        updateKeyFieldType: "Integer",
        exportFileName: "System Parameters",
        recordPostProcess: this.recordPostProcess,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "Factor",
              filter: [["Inactive", "=", "N"]],
              select: ["Code", "Description", "FactorInt", "Factorc"],
              sort: [{ selector: "Code", desc: false }],
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "system-parameters",
              mode: "review",
              idMode: "Number",
              idProperty: "Code",
            },
          },
          toolbar: {
            search: false,
            columnChooser: false,
            export: false,
            openFilter: true,
            expand: false,
            openFilterByDefault: true,
          },
          columns: [
            {
              screenField: "Code",
              dataField: "Code",
              label: "Code",
              alignment: "left",
              width: ColumnWidth.Code.width,
              minWidth: ColumnWidth.Code.minWidth,
            },
            {
              screenField: "Description",
              dataField: "Description",
              label: "Description",
              width: ColumnWidth.Description.width,
              minWidth: ColumnWidth.Description.minWidth,
              allowHiding: false,
            },
            {
              dataField: "Setting",
              calculateCellValue: (row) =>
                row.Factorc !== "" ? row.Factorc : row.FactorInt,
              label: "Setting",
              width: ColumnWidth.Setting.width,
              minWidth: ColumnWidth.Setting.minWidth,
              allowSearch: false,
            },
            {
              screenField: "SystemParameter",
              dataField: "SearchText",
              type: "Text",
              filterIndex: 0,
              visible: false,
              showInColumnChooser: false,
              allowHiding: false,
            },
          ],
        },
      },
    };
  },
  computed: {
    setFormConfig() {
      return {
        headerToolbar: {
          closeSplit: true,
          save: FeatureStorage.checkPermission(
            this.$route.meta.applicationFeatureCode,
            "create",
          ),
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                screenField: "Code",
                dataField: "Code",
                editorType: "dxTextBox",
                label: { text: "Code" },
                allowUpdate: false,
              },
              {
                screenField: "Description",
                dataField: "Description",
                editorType: "dxTextBox",
                label: { text: "Description" },
                allowUpdate: false,
              },
              {
                dataField: "FactorInt",
                editorType: "dxNumberBox",
                label: { text: "Setting" },
                visible: !this.formModel.IsTextSetting,
                allowUpdate: this.baseView.mode !== "review",
                validationRules: [
                  {
                    type: "custom",
                    message: "Setting must be a whole number.",
                    validationCallback: (e) =>
                      e.value == null || Number.isInteger(e.value),
                  },
                ],
              },
              {
                dataField: "Factorc",
                editorType: "dxTextArea",
                label: { text: "Setting" },
                visible: this.formModel.IsTextSetting,
                allowUpdate: this.baseView.mode !== "review",
                editorOptions: {
                  maxLength: 1000,
                },
              },
            ],
          },
        ],
        overWritePayload: this.overWritePayload,
      };
    },
  },
  methods: {
    // Computed once per record load (called from SplitViewTemplate's
    // getRecord()) - determines which of FactorInt/Factorc is the active
    // Setting for this Code, per technical-design-factors.md BR-03.
    recordPostProcess(data) {
      data["IsTextSetting"] = data["Factorc"] !== "";
      return data;
    },
    // Only the active Setting field is sent - never both - so an edit never
    // overwrites the inactive field's stored value (relevant for Codes
    // 253/10006, which have both FactorInt and Factorc populated).
    overWritePayload(payload) {
      if (payload.IsTextSetting) delete payload.FactorInt;
      else delete payload.Factorc;
      delete payload.IsTextSetting;
      return payload;
    },
  },
};
</script>
